import Vue from 'vue'
import Vuex from 'vuex'

import content from '../contentful'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    articles: [],
    signedIn: false
  },
  getters: {
    // Compute derived state based on the current state. More like computed property.
    listArticles (state) {
      return state.articles
    },
    getArticle: (state, getters) => (id, collection = state.articles) => {
      return collection[id - 1]
    }
  },
  mutations: {
    setArticles (state, articles) {
      state.articles = articles
    },
    signin (state, payload) {
      state.signedIn = payload
    }
  },
  actions: {
    getArticles (context) {
      content(payload => {
        context.commit('setArticles', payload[0])
      })
    }
    // Get data from server and send that to mutations to mutate the current state
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js